import { Element } from 'react-scroll';
import styles from './container.module.css';

const Container = ({ children, imageUrl, darkTheme }) => {
  const backgroundImage = imageUrl
    ? `${darkTheme ? 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), ' : ''}url(${imageUrl})`
    : undefined;

  return (
    <Element name="top">
      <div
        className={`${styles.container} container-fluid ${styles.divImage} p-0`}
        style={{
          backgroundImage,
          backgroundColor: darkTheme ? 'black' : 'white'
        }}
      >
        {children}
      </div>
    </Element>
  );
};

Container.displayName = 'Container';
export { Container };
